var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchVideoArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19322 1.90915L14.4059 6.82643C15.0559 7.1734 15.3008 7.9801 14.9528 8.62825C14.8284 8.85985 14.6381 9.04959 14.4058 9.17357L5.19321 14.0907C4.65149 14.3799 3.97724 14.1764 3.68725 13.6363C3.60078 13.4753 3.55554 13.2954 3.55554 13.1128L3.55554 2.88713C3.55554 2.27448 4.05366 1.77783 4.66812 1.77783C4.85133 1.77783 5.0317 1.82294 5.19322 1.90915Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchVideoArrowIcon);
export default __webpack_public_path__ + "static/media/watch-video-arrow-icon.5f635a3ca84b2228240332f81aaaeef3.svg";
export { ForwardRef as ReactComponent };